import React, { useContext, memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { usePopupState, bindToggle, bindPopover } from 'material-ui-popup-state/hooks';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { filterServiceMenuItemsForPopover } from '@signal/core/menuService/utils';
import MenuServiceContext from '@signal/core/menuService/Context';
import renderIf from '@signal/utils/renderIf';
import MenuList from '../MenuList';
import { AppMenuIcon, MenuButton, MenuWrapper, MenuComponentWrapper } from './styles';
export var MultiAppMenu = function MultiAppMenu(_ref) {
  var _ref$extraMenuItems = _ref.extraMenuItems,
      extraMenuItems = _ref$extraMenuItems === void 0 ? [] : _ref$extraMenuItems,
      onMenuItemClick = _ref.onMenuItemClick;

  var _useContext = useContext(MenuServiceContext),
      _useContext$response = _useContext.response,
      serviceMenu = _useContext$response === void 0 ? [] : _useContext$response;

  var menuClick = function menuClick(link) {
    popupState.close();
    onMenuItemClick(link);
  };

  var popupState = usePopupState({
    variant: 'popover',
    popupId: 'appMenuPopper'
  });
  var navMenu = useMemo(function () {
    return serviceMenu ? filterServiceMenuItemsForPopover(serviceMenu).concat(extraMenuItems) : [];
  }, [extraMenuItems, serviceMenu]);
  return renderIf(navMenu.length, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuButton, bindToggle(popupState), /*#__PURE__*/React.createElement(AppMenuIcon, null)), /*#__PURE__*/React.createElement(Popper, Object.assign({}, bindPopover(popupState), {
      placement: "top-start",
      popperOptions: {
        positionFixed: {
          enabled: true
        },
        modifiers: {
          preventOverflow: {
            enabled: false
          }
        }
      },
      transition: true,
      style: {
        zIndex: 9999
      }
    }), function (_ref2) {
      var TransitionProps = _ref2.TransitionProps;
      return /*#__PURE__*/React.createElement(Grow, Object.assign({}, TransitionProps, {
        id: "menu-list-grow",
        style: {
          transformOrigin: 'top left'
        }
      }), /*#__PURE__*/React.createElement(MenuWrapper, {
        elevation: 2
      }, /*#__PURE__*/React.createElement(ClickAwayListener, {
        onClickAway: popupState.close
      }, /*#__PURE__*/React.createElement(MenuComponentWrapper, null, /*#__PURE__*/React.createElement(MenuList, {
        listItems: navMenu,
        onMenuItemClick: menuClick,
        disablePadding: true,
        defaultDividers: true
      })))));
    }));
  });
};
MultiAppMenu.propTypes = {
  onMenuItemClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(MultiAppMenu);